import * as React from 'react';
const classNames = require('classnames');

import Checkbox, { CheckboxProps } from './Checkbox';
import Label from './Label';

interface Props {
	title?: {};
	name?: string;
	checkOptions: Array<CheckboxProps>;
	className?: string;
	children?: {};
	onUpdate: (e: any) => void;
	values: string;
}

const CheckboxGroupSerialize: React.StatelessComponent<Props> = props => {
	let valuesArray: Array<string>;
	if (!props.values) {
		valuesArray = [];
	} else {
		valuesArray = JSON.parse(props.values);
	}
	props.checkOptions.forEach(check => {
		check.value = check.name;
		if (valuesArray.indexOf(check.name) > -1) {
			check.checked = true;
		} else {
			check.checked = false;
		}
	});
	const onChange = (e: any) => {
		if (!props.values) {
			valuesArray = [];
		} else {
			valuesArray = JSON.parse(props.values);
		}
		let values;

		if (e.target.checked) {
			values = [...valuesArray, e.target.name];
		} else {
			values = valuesArray.filter(x => x !== e.target.name);
		}

		var eventProperties = {
			target: {
				value: JSON.stringify(values),
				type: 'checkboxSerial',
				name: props.name
			}
		};
		props.onUpdate(eventProperties);
	};

	return (
		<div className={classNames('form-group', props.className)}>
			<Label>{props.title}</Label>
			{props.checkOptions.map((check, index) => <Checkbox key={index} {...check} onChange={onChange} />)}
			{props.children}
		</div>
	);
};

export default CheckboxGroupSerialize;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/CheckboxGroupSerialize.tsx